import React from "react";

const ContactInfo = () => {
  return (
    <div className="review" id="hidden__cont">
    <p className="bold-white-text">Contact Info</p>
    <small className="bold-grey-text">Street Name City, Gwalior</small>
    <small className="bold-grey-text">vaspacx2022@gmail.com</small>
    <small className="bold-grey-text">(123)214-7479</small>
    </div>
  )
}

export default ContactInfo